export const TermsPage = () => {
    return (
        <div className="container bg-light p-2 p-lg-3 mt-5 mt-lg-3">
            <h1 className="">Terms &amp; Conditions</h1>
            <hr/>
            <h3>1. Restrictions</h3>
            <p>Licensee may not:</p>
            <ul>
                <li>Reverse engineer, decompile, or disassemble the Software;</li>
                <li>Modify, adapt, or create derivative works from the Software;</li>
                <li>Rent, lease, or sublicense the Software to any third party;</li>
                <li>Remove or alter any proprietary notices on the Software.</li>
            </ul>

            <h3>2. Intellectual Property Rights</h3>
            <p> The Software is licensed, not sold. Licensor retains all title, ownership rights, and intellectual property rights in and to the Software. </p>

            <h3>3. Updates and Support</h3>
            <p> Licensor may, but is not obligated to, provide updates or support services for the Software. </p>

            <h3>4. Termination</h3>
            <p> This Agreement is effective until terminated. Licensor may terminate this Agreement if Licensee breaches any term. Upon termination, Licensee must cease all use and destroy all copies of the Software. </p>

            <h3>5. Disclaimer of Warranty</h3>
            <p> The Software is provided “AS IS” without warranty of any kind. Licensor disclaims all warranties, express or implied, including but not limited to warranties of merchantability and fitness for a particular purpose. </p>

            <h3>6. Limitation of Liability</h3>
            <p> Licensor shall not be liable for any damages arising out of the use or inability to use the Software, even if advised of the possibility of such damages. </p>

            <h3>7. Governing Law</h3>
            <p> This Agreement shall be governed by the laws of the United Kingdom of Great Britain, without regard to its conflict of law principles. </p>

            <p> By installing or using the Software, you agree to be bound by the terms of this Agreement. </p>
        </div>
    );
};
